import { environment } from '@env';

function ensureTrailingSlash(value: string): string {
   return value.endsWith('/') ? value : `${value}/`;
}

function normalizePrefix(prefix: string | undefined, fallback: string): string {
   const value = prefix && prefix.trim().length > 0 ? prefix : fallback;
   return `${value!.replace(/^\/+|\/+$/g, '')}/`;
}

export function getApiPrefix(): string {
   return normalizePrefix((environment as any).apiPrefix, 'api/v1');
}

export function getODataPrefix(): string {
   return normalizePrefix((environment as any).odataPrefix, 'odata/v1');
}

export function buildApiUrl(baseUrl: string, domain: string): string {
   return `${ensureTrailingSlash(baseUrl)}${getApiPrefix()}${domain}`;
}

export function buildODataUrl(baseUrl: string, domain: string): string {
   return `${ensureTrailingSlash(baseUrl)}${getODataPrefix()}${domain}`;
}
